// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3IX5v","imgContainer":"styles_imgContainer__1OAfs","text":"styles_text__3kFIZ","rare":"styles_rare__1Qkmk","price":"styles_price__2Voyv"};